import React, { useContext } from 'react'
import ButtonClose from '../../atoms/button-close/button-close'

import panochin from '../../../assets/images/modal-final/zona-v.png'
import utero from '../../../assets/images/modal-final/utero.png'
import bellsuccess from '../../../assets/images/modal-final/bell-success.svg'
import Button from '../../atoms/button/button'

import { navigate } from 'gatsby'
import { Context } from '../../../context/app-context'

import Show from '../../../utils/show'
import {
  activity_stickers_link,
  LOCALE,
} from '../../../constants/activity-constants'
import { useEffect } from 'react'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import getUserInfo from '../../../utils/getUserInfo'

import './modalFinal.scss'
const tropicalize =
  process.env.LOCALE === 'es-AR' || process.env.LOCALE === 'es-PY'


const FigImage = props => {
  return (
    <figure className="f-modal-final__figure --center">
      <img className="f-modal-final__image" {...props} />
    </figure>
  )
}
const ModalFinal = ({ stickers = false, wallpapers = false }) => {
  const { dispatch } = useContext(Context)
  const userInfo = getUserInfo()
  const onclose = () => {
    dispatch({ type: 'clear-modal' })
    stickers
      ? navigate('/#stickers')
      : wallpapers
      ? navigate('/#wallpapers')
      : navigate('/#tarjetas')
  }
  const activity = stickers ? 'stickers' : wallpapers ? 'wallpapers' : 'card'
  const getMetric = (action, label) => {
    const event = {
      stickers: 'Interacciones_Stickers',
      wallpapers: 'Interacciones_Diseño_Wallpaper',
      card: 'Interacciones_Diseño_Tarjeta',
    }[activity]
    const category = {
      stickers: 'Stickers',
      wallpapers: 'Wallpapers',
      card: 'Tarjetas',
    }[activity]
    return {
      event,
      category,
      action,
      label,
      card_name: 'Mi parte favorita de la Navidad son ustedes',
      Location: 'nosotras.com/navidad',
      user_data: [
        {
          nombre: userInfo.name,
          apellido: userInfo.lastName,
          celular: userInfo.cellPhone,
          correo: userInfo.email,
          ciudad: userInfo.location.cityName,
          departamento: userInfo.location.countryStateName,
          pais: userInfo.countryName,
        },
      ],
      log_status: 'Yes',
    }
  }

  useEffect(() => { 
    pushEventData(getMetric('view', 'Descarga exitosa'))
  }, [])
  return (
    <div className="f-modal-final">
      <Show valid={stickers}>
        <ButtonClose
          className="f-modal-final__close "
          onClick={onclose}
          title="cerrar modal y regresar al home"
        />
      </Show>
      <article className="f-modal-final__container">
        <aside className="f-modal-final__aside">
          <FigImage src={panochin} alt="tu zona v" />
        </aside>
        <aside className="f-modal-final__aside --main">
          <FigImage src={bellsuccess} alt={'jingle bell'} />
          <h1>
            <Show valid={!stickers}>
              Descarga <br />
              Exitosa
            </Show>
            <Show valid={stickers}>
              <Show valid={tropicalize || ['es-PE', 'es-CL'].includes(LOCALE)}>
                Canjé <br />
                Exitoso
              </Show>
              <Show valid={!tropicalize}>
                Redención <br />
                Exitosa
              </Show>
            </Show>
          </h1>
          <Show valid={!stickers}>
            <Button
              text={'Volver'}
              onClick={onclose}
              metric={getMetric('click')}
            />
          </Show>
          <Show valid={stickers}>
            <Button
              text={'Ver stickers'}
              metric={getMetric('click')}
              onClick={() => {
                window.open(activity_stickers_link, '_BLANK')
              }}
            />
          </Show>
        </aside>
        <aside className="f-modal-final__aside">
          <FigImage src={utero} alt="tu utero" />
        </aside>
      </article>
    </div>
  )
}

export default ModalFinal
